import moedaService from '@/api/financial/moedaServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) => moedaService.loadTable(pageConfig).then(result => {
      commit('LOAD_LIST_MOEDA', result.data.content)
      resolve(result)
    }).catch(err => reject(err)))
  },
  insertNewMoeda({ commit }, data) {
    return moedaService.insertNewMoeda(data).then(result => result).catch(error => error)
  },
  prepareToEditMoeda({ commit }, data) {
    commit('PREPARE_TO_EDIT_MOEDA', data)
  },
  editMoeda({ commit }, data) {
    return moedaService.editMoeda(data).then(result => result).catch(error => error)
  },
  resetMoeda({ commit }) {
    commit('RESET_MOEDA')
  },
  delete({ commit }, id) {
    return moedaService.deleteMoeda(id).then(result => result).catch(error => error)
  },
}
